import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { Loader2, Disc3 } from "lucide-react";
import { api } from "@/lib/api";
import { SiteFooter } from "@/components/SiteFooter";

export default function BatchSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const siteKey = params.get("site_key");
  const navigate = useNavigate();
  const [stuck, setStuck] = useState(false);

  useEffect(() => {
    if (!sessionId || !siteKey) { setStuck(true); return; }
    let alive = true;
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (!alive) return;
        if (data.payment_status === "paid") {
          const { data: latest } = await api.get(`/sites/${siteKey}/latest-job`);
          if (alive) navigate(`/recording-studio/${latest.job_id}`);
          return;
        }
        attempts += 1;
        if (attempts > 20) { setStuck(true); return; }
        setTimeout(poll, 1500);
      } catch (e) {
        if (alive) setTimeout(poll, 2500);
      }
    };
    poll();
    return () => { alive = false; };
  }, [sessionId, siteKey, navigate]);

  return (
    <div data-testid="batch-success-page" className="min-h-screen bg-obsidian text-white flex flex-col">
      <div className="flex-1 flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        {!stuck ? (
          <>
            <div className="relative mx-auto mb-8 h-16 w-16">
              <Disc3 className="h-16 w-16 text-gold vinyl-spin" />
              <Loader2 className="absolute -bottom-2 -right-2 h-6 w-6 text-coral animate-spin" />
            </div>
            <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mb-4">
              Payment confirmed.
            </h1>
            <p className="text-slate-400 text-lg">
              The studio is cutting your 3 fresh takes right now...
            </p>
          </>
        ) : (
          <>
            <h1 className="font-display text-3xl font-bold tracking-tight mb-4">Almost there</h1>
            <p className="text-slate-400 mb-8">
              Your payment went through — your new takes will appear in your studio session in a moment.
            </p>
            <Link to="/" data-testid="batch-success-home" className="text-gold underline">Back to the studio</Link>
          </>
        )}
      </div>
      </div>
      <SiteFooter />
    </div>
  );
}
